import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  Collapse,
  IconButton,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  card: {
    margin: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent:'space-between',
    maxWidth: 345,
    minWidth:100,
    minHeight:410
  },
  media: {
    height: 140,
  },
  contactCollapse:{
    margin : theme.spacing(0),
    padding: theme.spacing(1),
    paddingBottom: 0,
  },
  bigAvatar: {
    margin: 10,
    width: 150,
    height: 150,
    alignSelf: 'center',
    backgroundColor: '#aaaaaa',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

export default function ProfileCard(props) {
  const classes = useStyles();

  const [expanded, setExpanded] = React.useState(false);

  function handleExpandClick(event) {
    setExpanded(!expanded);
  };

  //wrapping everything in a div solves the multiple collapse problem
  //redundant but necessary
  return (
    <div>
      <Card 
        key={props.contactName+props.contactDesc+props.contactInfo} 
        className={classes.card}
      >
        <div 
          style={{
            backgroundColor: "#446692", 
            display: 'flex', 
            flexDirection: 'column'
          }}
        >
          <Avatar alt="Test" src={props.img} className={classes.bigAvatar} />
        </div>
        <CardContent style={{flexGrow: 2}}>
        <Typography gutterBottom variant="h5" component="h2">
          {props.contactName}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {props.contactDesc}
        </Typography>
        </CardContent>
      <CardActions style={{flexGrow: 1}} disableSpacing>
      <Typography h4>Contact Information</Typography>
        <IconButton
          className={clsx(classes.expand, {[classes.expandOpen]: expanded,})}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton>
      </CardActions>
      <Collapse 
        className={classes.contactCollapse} 
        in={expanded} 
        timeout="auto" 
        unmountOnExit
      >
        <CardContent >
          <Typography paragraph>{props.contactInfo}</Typography>
        </CardContent>
      </Collapse>
      </Card>
    </div>
  );
}